import _ from "lodash";
import axiosHttp from "./interceptor";

export const roundOff = (
	inputValue,
	trailingDecimalDigits = 7,
	precision = 7
) => {
	if (typeof inputValue === "string") {
		inputValue = parseFloat(inputValue);
	}

	// Check if the inputValue is NaN
	if (isNaN(inputValue)) {
		return "null";
	}

	const roundedNumber = _.round(inputValue, precision);
	let roundedNumberStr = roundedNumber.toString();
	if (roundedNumberStr.includes("e")) {
		roundedNumberStr = roundedNumber.toLocaleString("fullwide", {
			useGrouping: false,
		});
	}
	let [integerPart, decimalPart] = roundedNumberStr.split(".");
	if (decimalPart) {
		decimalPart = decimalPart
			.slice(0, trailingDecimalDigits)
			.padEnd(trailingDecimalDigits, "0");
	} else {
		decimalPart = "0".repeat(trailingDecimalDigits);
	}
	const formattedNumber = `${integerPart}.${decimalPart}`;
	return formattedNumber;
};

export const preventScientificNotation = (e) => {
	if (["e", "E", "+", "-"].includes(e.key)) {
		e.preventDefault();
	}
};
export const preventSpecialCharacters = (e) => {
	if (["e", "E", "+"].includes(e.key)) {
		e.preventDefault();
	}
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getQueryData = (payload) => {
	return axiosHttp.post(`${BASE_URL}api/query`, payload);
};

export const INPUT_STEP_VALUE = 0.0000001;

export const getYearOptions = (isLegacyReportsEnabled) => {
		const currentYear = Math.max(new Date().getFullYear(), 2029); // Get the current year
		const startYear = 2018; // Define the starting year
		const hideStart = 2018; // for legacy reports hide from 2018 to 2022
	    const hideEnd = 2022;

		const options = [];

		for (let year = currentYear + 1; year >= startYear; year--) {
			if (isLegacyReportsEnabled && year >= hideStart && year <= hideEnd) {
			continue;
		   }  
			options.push({ label: year, value: year });
		}

		return options;
	};

export const formatNotificationTemplateName = (name) => {
	if (!name) return "";
	return name
		.split("_")
		.map((word) => {
			// If the word is a number, keep it as is
			if (/^\d+$/.test(word)) {
				return word;
			}
			// Otherwise, convert to title case (first letter uppercase, rest lowercase)
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		})
		.join(" ");
};
